import { cabeceraStyles } from "./CabeceraStyles"
import { Container, Tooltip, Button } from "@material-ui/core"
import { useSelector } from "react-redux"
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn'
import { useHistory, useLocation } from "react-router-dom"
import { FormatoFechaIso } from "../../../utils/FormatFecha"
const Cabecera = () => {
    const classes = cabeceraStyles()
    const { cliente } = useSelector(store => store.calendario)
    const history = useHistory()
    const location =  useLocation()
    const onReturn = () => {
        if (location.state?.reservas) {
            history.goBack()
            return null
        }
        history.push({
            pathname: `/Grupo/${cliente?.paquete?.Nombre}/${FormatoFechaIso({date: cliente?.paquete?.Fecha_Viaje, formato: "MMddyyyyHHmmss"})}`
        })
    }
    return (
        <Container>
            <div className={classes.root}>
                <div className={classes.cabecera}>
                    <ul className={classes.lista}>
                        <li>Cliente: <b>{`${cliente?.paquete?.cuenta?.Nombre} ${cliente?.paquete?.cuenta?.Apellido_Paterno} ${cliente?.paquete?.cuenta?.Apellido_Materno}`}</b></li>
                    </ul>
                    <div>
                        <Tooltip title="regresar">
                            <Button onClick={onReturn} variant="contained">
                                <KeyboardReturnIcon />
                                Regresar
                            </Button>
                        </Tooltip>
                    </div>
                </div>
                <div className={classes.flexLista}>
                    <div>
                        <ul className={classes.lista}>
                            <li>Paquete: <b>{`${cliente?.paquete?.Nombre}`}</b></li>        
                            <li>Paquete para: <b>{`${cliente?.paquete?.Numero_Personas} personas`}</b></li>
                            <li>Fecha contratación: <b>{`${FormatoFechaIso({date: cliente?.paquete?.FechaContratacion, formato: "dd MMMM yyyy" })}`}</b></li>
                            <li>Fecha salida:  <b>{`${FormatoFechaIso({date: cliente?.paquete?.Fecha_Viaje, formato: "dd MMMM yyyy" })}`}</b></li>
                        </ul>
                    </div>
                    <div>
                        <ul className={classes.lista}>
                            <li>Teléfono: <b>{`${cliente?.paquete?.cuenta?.Telefono_Contacto}`}</b></li>
                            <li>Correo: <b>{`${cliente?.paquete?.cuenta?.eMail}`}</b></li>
                        </ul>
                    </div>
                </div>
            </div>
        </Container>
    )
}
export default Cabecera